__turbopack_context__.v({
  "accept": "marketing-analytics-module__W8YPDW__accept",
  "actions": "marketing-analytics-module__W8YPDW__actions",
  "panel": "marketing-analytics-module__W8YPDW__panel",
  "preview": "marketing-analytics-module__W8YPDW__preview",
});
